<template>
  <div class="flex h-full max-h-full min-h-0 flex-1 flex-col overflow-hidden rounded-md">
      <PdfViewer
        ref="pdf-viewer"
        :url="`/third-party-cost-payment/${third_party_cost_payment_id}/render`"
        :params="printSettings"
        :title="title"
        :back-route="{ name: 'third_party_cost_index_route' }"
        :info-model="{
          type: 'ThirdPartyCostPayment',
          id: third_party_cost_payment_id,
          dossier_id: null
        }"
        reverse-panel-position
      />
  </div>
</template>

<script>
import PdfViewer from '@c/Media/PdfViewer.vue'
import LoadingComponent from '@c/TheLoadingComponent.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ThirdPartyCostPaymentPrintPage',
  components: {
    PdfViewer,
    LoadingComponent
  },
  props: ['third_party_cost_payment_id'],
  data() {
    return {
      payment: null,
      printSettings: {}
    }
  },
  computed: {
    title() {
      return `Liste de frais de tiers payé(s) - ${this.payment?.reference ?? ''}`
    }
  },
  mounted() {
    console.log('ok ici')
    // const third_party_cost_payment_id = this.$route.params.third_party_cost_payment_id
    // if (third_party_cost_payment_id) {
    //   this.fetchInvoiceItemsWithHeaders(this.$route.params.third_party_cost_id)
    // }
  },
  methods: {
    ...mapActions({
      fetchPaidInvoiceItems: 'invoicing/fetchPaidInvoiceItemsByThirdPartyCostId',
      fetchHeaderForInvoice: 'invoicing/fetchHeaderForInvoice'
    }),

    async fetchInvoiceItemsWithHeaders(thirdPartyCostId) {

      const invoiceItems = await this.fetchPaidInvoiceItems({ thirdPartyCostId: thirdPartyCostId })
      this.invoiceItems = invoiceItems

      if (!invoiceItems.length) return

      const invoiceId = invoiceItems[0].invoicing_id
      const response_header = await this.fetchHeaderForInvoice({ invoice_id: invoiceId })

      this.headers = response_header.headers

      this.printSettings = {
        ...this.printSettings,
        header:
          this.headers.find((header) => header.favorite_invoice)?.id ??
          this.headers.find((header) => header.favorite)?.id ??
          null,
        language: this.$i18n.locale
      }
    },
    refreshDocument() {
      this.$refs['pdf-viewer'].reload()
    }
  }
}
</script>
